// extracted by mini-css-extract-plugin
module.exports = {"spin":"dataTable-modulespin-Bhdyv"};